import { ChangeEvent, memo, ReactNode } from "react";
import { RadioButton } from "../../RadioButton";

import styles from "./style.module.scss";

type OptionProps = {
  label: string,
  checked: boolean,
  autoFocus?: boolean,
  children: ReactNode,
  onCheckedChange: (e?: ChangeEvent<HTMLInputElement>, value?: boolean) => void
};

export default memo<OptionProps>(({ autoFocus, label, onCheckedChange, checked, children }) =>
  <div className={styles.optionBlock}>
    <RadioButton
      autoFocus={autoFocus}
      className={styles.option}
      value={checked}
      onChange={onCheckedChange}
      label={label}
    />
    {
      checked &&
      <div className={styles.optionContent}>
        {children}
      </div>
    }
  </div>,
);
